/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelreplysent2Inputs */

const en_channelreplysent2 = /** @type {(inputs: Channelreplysent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply sent`)
};

const de_channelreplysent2 = /** @type {(inputs: Channelreplysent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort gesendet`)
};

/**
* | output |
* | --- |
* | "Reply sent" |
*
* @param {Channelreplysent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelreplysent2 = /** @type {((inputs?: Channelreplysent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelreplysent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelreplysent2(inputs)
	return de_channelreplysent2(inputs)
});
export { channelreplysent2 as "channelReplySent" }